import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=87983092&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=87983092&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87983092",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87983092')) {
      api.createRecord('87983092', component.options)
    } else {
      api.reload('87983092', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=87983092&scoped=true&", function () {
      api.rerender('87983092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2z2wjo4nUn78K/JS/comp/Paginate.vue"
export default component.exports